import { render, staticRenderFns } from "./auto-scroll-table.vue?vue&type=template&id=44cb4048&"
import script from "./auto-scroll-table.vue?vue&type=script&lang=js&"
export * from "./auto-scroll-table.vue?vue&type=script&lang=js&"
import style0 from "./auto-scroll-table.vue?vue&type=style&index=0&id=44cb4048&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports